import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const JWT_KEY = 'reqshare_jwt';
const RETURN_URL_KEY = 'reqshare_auth_return';

export function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      localStorage.setItem(JWT_KEY, token);
      window.postMessage({ type: 'REQSHARE_TOKEN_UPDATE', token }, '*');
    }

    const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
    sessionStorage.removeItem(RETURN_URL_KEY);

    navigate(returnUrl || '/', { replace: true });
  }, [navigate]);

  return null;
}
